import React from 'react';

const Card = ({ 
  children, 
  padding = 'lg',
  hover = false,
  onClick,
  className = '',
  ...props 
}) => {
  const paddingClasses = {
    none: 'p-0',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-5',
    xl: 'p-6',
  };

  const baseClasses = 'bg-surface-raised border border-surface-border rounded-lg transition-colors duration-150';
  const hoverClasses = hover ? 'hover:border-accent/20 hover:shadow-glow cursor-pointer' : '';
  const clickableClasses = onClick ? 'cursor-pointer' : '';

  const combinedClasses = `${baseClasses} ${paddingClasses[padding] || paddingClasses.lg} ${hoverClasses} ${clickableClasses} ${className}`.trim();

  return (
    <div 
      className={combinedClasses}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
